module.exports = __webpack_public_path__ + "static/media/brackets.819cb595.svg";